import { render, staticRenderFns } from "./myactivity.vue?vue&type=template&id=2f542464&"
import script from "./myactivity.vue?vue&type=script&lang=js&"
export * from "./myactivity.vue?vue&type=script&lang=js&"
import style0 from "./myactivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports